import { GlobalData } from './../../general/services/global-data.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dps-plot-chart-sidebar-toggle',
  templateUrl: './plot-chart-sidebar-toggle.component.html',
  styleUrls: ['./plot-chart-sidebar-toggle.component.scss']
})
export class PlotChartSidebarToggleComponent implements OnInit {
  constructor(public globalData: GlobalData) { }

  ngOnInit() {
  }

  togglePlotChartSidebar() {
    this.globalData.applicationState.plotChartSidebarOpen = !this.globalData.applicationState.plotChartSidebarOpen;
    this.globalData.applicationState.regionsSidebarOpen = false;
    this.globalData.applicationState.helpSidebarOpen = false;
    this.globalData.applicationState.mobileActionsMenu = false;
  }
}
